'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _define = require('./define');

var _define2 = _interopRequireDefault(_define);

var _toFunction = require('./toFunction');

var _toFunction2 = _interopRequireDefault(_toFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Return success or failure based on predicate evaluation. If success or
 * failure are functions, returns executed result with passed in parameter;
 *
 * @module ternaryWith
 * @func
 * @since 1.9.0
 * @param {*} failure
 * @param {*} success
 * @param {*} predicate
 * @param {*} val
 * @return {*}
 * @example
 *
 *     const foo = val => val + 1;
 *     const bar = val => val - 1;
 *     ternaryWith(bar, foo, true, 3); //=> 4
 *     ternaryWith(bar, foo, false, 2); //=> 1
 */

var internal = function internal(failure, success, predicate, val) {
  return (0, _toFunction2.default)(predicate)(val) ? (0, _toFunction2.default)(success)(val) : (0, _toFunction2.default)(failure)(val);
};

var ternary = (0, _define2.default)(internal);

exports.default = ternary;